import { getJwtExpiryTimeMs, resolveAccessTokenExpiryMs } from './authExpiry';

const TOKEN_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  TOKEN_EXPIRY: 'tokenExpiry',
  OLD_JWT: 'jwt',
};

export const tokenStorage = {
  /**
   * Persist access token and expiry.
   * @param {string} accessToken
   * @param {number|undefined} expiresInSeconds - TTL from signin / SSO (seconds). If omitted/invalid, uses JWT `exp`.
   */
  saveAccessToken: (accessToken, expiresInSeconds) => {
    const expiryTime = resolveAccessTokenExpiryMs(accessToken, expiresInSeconds);

    localStorage.setItem(TOKEN_KEYS.ACCESS_TOKEN, accessToken);
    localStorage.removeItem(TOKEN_KEYS.REFRESH_TOKEN);
    if (expiryTime != null) {
      localStorage.setItem(TOKEN_KEYS.TOKEN_EXPIRY, String(expiryTime));
    } else {
      localStorage.removeItem(TOKEN_KEYS.TOKEN_EXPIRY);
    }
    localStorage.setItem(TOKEN_KEYS.OLD_JWT, accessToken);
  },

  getAccessToken: () => {
    const accessToken = localStorage.getItem(TOKEN_KEYS.ACCESS_TOKEN);
    if (accessToken) return accessToken;
    return localStorage.getItem(TOKEN_KEYS.OLD_JWT);
  },

  getTokenExpiry: () => {
    const expiry = localStorage.getItem(TOKEN_KEYS.TOKEN_EXPIRY);
    return expiry ? parseInt(expiry, 10) : null;
  },

  isTokenExpired: () => {
    const token = tokenStorage.getAccessToken();
    if (!token) return true;
    const stored = tokenStorage.getTokenExpiry();
    const expiryMs = stored != null ? stored : getJwtExpiryTimeMs(token);
    if (expiryMs == null) return false;
    return Date.now() >= expiryMs;
  },

  clearTokens: () => {
    console.log('[Token Storage] 🗑️ Clearing tokens', {
      timestamp: new Date().toISOString(),
      stack: new Error().stack,
    });
    localStorage.removeItem(TOKEN_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(TOKEN_KEYS.REFRESH_TOKEN);
    localStorage.removeItem(TOKEN_KEYS.TOKEN_EXPIRY);
    localStorage.removeItem(TOKEN_KEYS.OLD_JWT);
  },

  isAuthenticated: () => {
    return !!tokenStorage.getAccessToken();
  },
};
